var map = {
	"./mulan_tiktok.png": "b412",
	"./mulan_xiaohongshu.png": "0269",
	"./mulan_zhihu.png": "aacd",
	"./tiktok.png": "f5aa",
	"./wechat.png": "87de",
	"./weibo.png": "2df2",
	"./xiaohongshu.png": "32fd",
	"./zhihu.png": "30d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cd89";